<template>
  <v-container class="ma-0 pa-0 px-2" v-if="calendar">
    <v-row no-gutters align="center" justify="space-around">
      <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9">
        <calendar-view-header v-model="calendar"/>
      </v-col>
    </v-row>

    <v-tabs v-model="tab" grow class="mt-2">
      <v-tab href="#tab-1"> Perfil </v-tab>
      <v-tab href="#tab-2"> Agendar </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item value="tab-1">
        <calendar-profile v-model="calendar" class="pa-6"/>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <calendar-schedule v-model="scheduleParams" :calendar="calendar" />
        <!-- :scheduleParams="scheduleParameters" -->
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import CalendarViewHeader from '@/components/calendars/CalendarViewHeader';
import CalendarProfile from '@/components/calendars/CalendarProfile';
import CalendarSchedule from '@/components/calendars/CalendarSchedule';

export default {
  props: {
    value: {
      type: Object,
    },
    scheduleParams: {
      type: Object,
    },
  },
  data: () => ({
    calendar: null,
    scheduleParameters: null,
    tab: 'tab-1',
    removeLoading: false,
  }),
  created() {
    this.calendar = this.value;
    this.scheduleParameters = this.scheduleParams;
  },
  watch: {
    value(vl) {
      this.calendar = vl;
      this.scheduleParameters.calendarId = vl.calendarId;
    },
    scheduleParams(vl) {
      this.scheduleParameters = vl;
    },
  },
  components: {
    CalendarViewHeader,
    CalendarProfile,
    CalendarSchedule,
  },
};
</script>
